import React from "react";
// Assuming you are using 'useHistory' from 'react-router-dom' inside the component where this is rendered,
// OR you are passing 'history' as a prop.
import { Container, Row, Col, Button } from "react-bootstrap";
import ImgWebp from "../Healthcare Software/Img/patnerwithus.gif";
import Img2 from "../Healthcare Software/Img/medisevashospitalerpImg/imghomepagebanner 2.webp";
import Img3 from "../Healthcare Software/Img/medisevashospitalerpImg/imghomepagebanner 3.webp";
import Img4 from "../Healthcare Software/Img/medisevashospitalerpImg/imghomepagebanner 4.webp";
import Img5 from "../Healthcare Software/Img/medisevashospitalerpImg/imghomepagebanner 5.webp";

const servicesData = [
  // ... (your servicesData remains unchanged)
  {
    imgSrc: Img2,
    imgAlt: "Hero Image",
    title: "Impressive Prescriptions to Amaze your Patients.",
    description: `We recognize the necessity for the "Ideal Prescription". For your patients, it represents the sole concrete result of all the work you are investing in EMR. Transition to the next generation of prescription technology. Any format, any assortment of data, essential charts, laboratory trends, or visuals. Are you weary of hearing, 'it cannot be accomplished' - reach out to us. Any design you can envision, we can bring it to life.`,
    imgFirst: true,
  },
  {
    imgSrc: Img3,
    imgAlt: "Hero Image",
    title: "Extremely user-friendly EMR, tailored specifically for your needs.",
    description: `Our groundbreaking technology employs clinical intelligence to convert all of your paper forms and consents into digital format. You have the ability to further customize it to align with your workflows. The final outcome is a personalized EMR tailored specifically for you. This system includes only the essential elements you require. No excess, no distractions, no disarray.`,
    imgFirst: false,
  },
  {
    imgSrc: Img4,
    imgAlt: "Hero Image",
    title: "360 Degree View On Visits.",
    description: `Our 360-degree view on visits provides a comprehensive understanding of patient interactions. It consolidates all relevant data, ensuring that healthcare providers have a complete picture of each patient's journey. This holistic approach enhances decision-making and improves patient outcomes.`,
    imgFirst: true,
  },
  {
    imgSrc: Img5,
    imgAlt: "Hero Image",
    title: "An image can convey a multitude of meanings.",
    description: `Utilize the intelligent imaging tool available on the Medisevas cloud platform. It automatically filters the library according to the patient's gender. It connects directly to your camera, allowing you to capture images directly within Medisevas. You can annotate, highlight, and compare Before & After images, among other features.`,
    imgFirst: false,
  },
];

// ********************************************************************
// FIX: Accepting 'history' as a prop and defining 'navigateAndScroll'
// ********************************************************************
const AyurvedicClinicalModule = ({ history }) => {
  // Navigation function matching the user's requirement
  const navigateAndScroll = (path) => (e) => {
    e.preventDefault();
    if (history && typeof history.push === "function") {
      history.push(path);
    } else {
      // Fallback for non-router environments or modern react-router-dom v6 (replace with useNavigate hook)
      // If history is not available, it still performs the scroll and navigates via native URL change
      window.location.href = path;
    }
    window.scrollTo(0, 0);
  };

  return (
    <>
      {/* ... (Your style block remains unchanged) ... */}
      <style>{`
        /* --- Color Variables (Defined for clarity) --- */
        :root {
          --medisevas-blue: #0084d9; /* Accent Color */
          --medisevas-green: #0d622b; /* Heading Color */
          --medisevas-black: #000; /* Default Text Color */
          --medisevas-light-bg: #f7f9fa; /* Subtle background for features section */
        }
        
        /* --- General Section Styling (Global) --- */
        .section, section {
          scroll-margin-top: 90px;
          overflow: clip;
          color: var(--medisevas-black, #000);
          background-color: #fff;
          padding: 80px 0; /* Increased padding */
        }
        @media (max-width: 1199px) {
          .section, section {
            scroll-margin-top: 66px;
            padding: 60px 0;
          }
        }
        .light-background {
          background-color: #f9fafb; /* light neutral background for services */
        }

        /* --- Section Title Styling --- */
        .section-title h2 {
          color: var(--medisevas-green, #0d622b);
          font-weight: 700;
          position: relative;
          padding-bottom: 15px;
          text-transform: uppercase;
        }
        .section-title h2:after {
          content: "";
          position: absolute;
          display: block;
          width: 60px;
          height: 4px;
          background: var(--medisevas-blue, #0084d9);
          bottom: 0;
          left: calc(50% - 30px);
          border-radius: 2px;
        }
        .section-title p {
          color: #444;
          font-size: 1.1rem;
          max-width: 800px; 
          margin: 10px auto 0;
        }

        /* --- Tab Navigation Styling (section#features) --- */
        section#features {
            background-color: var(--medisevas-light-bg);
        }

        section#features .nav-tabs {
          border: none;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08); /* Soft Shadow */
          border-radius: 12px; /* Slightly more rounded */
          background-color: #fff; /* White background for the tabs container */
          padding: 10px;
          flex-wrap: wrap; 
        }

        section#features .nav-item {
          margin: 4px; /* Space between tabs in a grid layout */
          flex-grow: 1; 
          flex-basis: auto; 
        }
        
        section#features .nav-tabs .nav-link {
          border: none;
          padding: 10px 15px;
          transition: all 0.3s ease-in-out;
          border-radius: 8px;
          font-weight: 600;
          color: #555 !important;
          background: none !important;
          display: block;
          text-align: center;
        }
        
        section#features .nav-tabs .nav-link h4 {
          margin: 0;
          font-weight: 600;
          font-size: 0.9rem;
          line-height: 1.2;
        }
        
        /* Active Tab Styling */
        section#features .nav-tabs .nav-link:hover:not(.active) {
           color: var(--medisevas-blue) !important;
           background-color: #f0f7ff !important;
        }
        
        section#features .nav-tabs .nav-link.active {
          color: #fff !important;
          background-color: var(--medisevas-blue) !important;
          box-shadow: 0 2px 8px rgba(0, 132, 217, 0.3);
        }
        
        /* --- Tab Pane Content Styling --- */
        section#features .tab-content {
          padding-top: 30px !important;
        }

        section#features .tab-pane {
          padding:40px;
          padding-top: 20px;
          padding-bottom: 20px;
          background-color: #fff;
          border-radius: 12px;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
        }
        
        section#features .tab-pane h3 {
          color: var(--medisevas-green, #0d622b);
          font-weight: 700;
          font-size: 1.8rem;
          margin-bottom: 1rem;
        }
        section#features .tab-pane p.fst-italic {
          font-style: italic;
          margin-bottom: 1.5rem;
          font-size: 1.05rem;
          color: #555;
        }

        section#features table {
          width: 100%;
        }
        section#features table td {
          vertical-align: top;
        }
        section#features table ul {
          padding-left: 0;
          list-style: none;
        }
        section#features table ul li {
          margin-bottom: 0.75rem;
          list-style: none;
          display: flex;
          align-items: flex-start;
          font-size: 0.95rem;
          color: var(--medisevas-black, #000);
          line-height: 1.4;
        }
        section#features table ul li i.bi-check2-all {
          color: var(--medisevas-blue, #0084d9); 
          margin-right: 0.7rem;
          font-size: 1.1rem;
          flex-shrink: 0;
          margin-top: 3px;
        }
        section#features img.img-fluid {
          max-width: 100%;
          height: auto;
          border-radius: 12px;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1); 
          user-select: none;
        }

        /* --- Service Card Styling (Alternating Blocks) --- */
        .service-card {
          background: #ffffff;
          box-shadow: 0 6px 15px rgba(0, 0, 0, 0.1);
          border-radius: 12px; 
          padding: 40px; 
          transition: box-shadow 0.3s ease;
          display: flex;
          flex-direction: column;
          gap: 2rem;
          align-items: center; 
        }
        .service-card:hover {
          box-shadow: 0 12px 30px rgba(0, 0, 0, 0.15);
        }
        
        @media (min-width: 992px) {
          .service-card {
            flex-direction: row;
            align-items: center; 
          }
          .service-img-wrapper {
            max-width: 45%; 
            flex-shrink: 0;
          }
          .service-text {
            max-width: 55%;
            padding: 0 20px; 
          }
        }
        
        .service-text h4 {
          color: var(--medisevas-green);
          font-weight: 700;
          margin-bottom: 1rem;
          font-size: 1.75rem;
        }
        
        .service-text p {
          color: #555;
          line-height: 1.7;
          font-size: 1.05rem;
        }
        
        /* --- CTA Section Styling --- */
        .medisevas-dark-bg {
           background: #a3cfbb;
          color: var(--medisevas-black);
          padding: 80px 0;
        }
        .py-5 {
          padding-top: 3rem !important;
          padding-bottom: 3rem !important;
        }
        .medisevas-dark-bg h3 {
          color: var(--medisevas-green);
          font-weight: 700;
          margin-bottom: 1.5rem;
          font-size: 2rem;
        }
        .medisevas-dark-bg p {
          font-size: 1.1rem;
          margin-bottom: 2.5rem;
          color: #444;
          max-width: 800px;
          margin-left: auto;
          margin-right: auto;
        }
        
        /* Button Styles */
        .medisevas-btn {
          background-color: var(--medisevas-blue);
          border: none;
          color: #fff;
          padding: 10px 20px;
          margin: 0 8px;
          border-radius: 6px;
          font-weight: 600;
          transition: background 0.2s;
          cursor: pointer;
          text-decoration: none;
          display: inline-block;
        }
        .medisevas-btn-success {
          background-color: var(--medisevas-green);
        }
        .medisevas-btn-outline {
          background: none;
          color: var(--medisevas-green);
          border: 2px solid var(--medisevas-green);
        }
        .medisevas-btn:hover,
        .medisevas-btn-success:hover,
        .medisevas-btn-outline:hover {
          background-color: var(--medisevas-green);
          color: #fff;
          text-decoration: none;
        }
        .hero-buttons {
          margin-top: 30px;
        }
        
        .medisevas-tab-pane {
  background: #fff;
  border-radius: 12px;
  margin-bottom: 32px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
  padding: 40px;
}

.align-items-center {
  align-items: center;
}

.py-4 {
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important;
}

/* Typography */
.mb-3 {
  margin-bottom: 1rem !important;
}

.fst-italic {
  font-style: italic !important;
}

.mt-3 {
  margin-top: 1rem !important;
}

.mt-4 {
  margin-top: 1.5rem !important;
}

.mt-lg-0 {
  margin-top: 0 !important;
}

.mt-1 {
  margin-top: 0.25rem !important;
}

/* Layout */
.d-flex {
  display: flex !important;
}

.flex-column {
  flex-direction: column !important;
}

.justify-content-center {
  justify-content: center !important;
}

.align-items-center {
  align-items: center !important;
}

.text-center {
  text-align: center !important;
}

/* Feature List */
.medisevas-feature-list {
  padding-left: 0;
}

.medisevas-feature-list li {
  margin-bottom: 12px;
  list-style: none;
  display: flex;
  align-items: flex-start;
  padding-left: 0;
  font-size: 1rem;
  color: #333;
}

.medisevas-feature-list li i {
  color: var(--medisevas-blue);
  margin-right: 10px;
  font-size: 1.2em;
  min-width: 20px;
}

/* Image */
.img-fluid {
  max-width: 100%;
  height: auto;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  user-select: none;
}
      `}</style>
      <div>
      <div className="light-background">
      <div className="container">
        {/* 1. Features/Tabs Section */}
        <section id="features" className="features section mt-5">
          <Container className="section-title text-center mb-5">
            <h2>
              Why Choose The Medisevas Cloud-based Healthcare Software &amp;
              Solutions
            </h2>
            <p>
              Providing accurate data, smooth department integration, and
              adaptable solutions that boost overall effectiveness and patient
              care, Medisevas Software is a dependable hospital management
              system that improves hospital operations.
            </p>
          </Container>
          <Container>
            <div className="d-flex justify-content-center">
              <ul
                className="nav nav-tabs nav-justified shadow-sm"
                id="featuresTab"
                role="tablist"
              >
                {/* Tabs */}
                {[
                   "Outpatient", "Inpatient", "Appointment", "Billing", "Pharmacy", "Laboratory", "OT", "Nursing", "Telehealth", "Account",
                "Ambulance", "BloodBank", "HRMS", "Inventory", "Imaging", "Referal", "Inssurance", "MIS,Reporting", "Analytics", "Reception",
                ].map((tab, i) => (
                  <li className="nav-item" role="presentation" key={tab}>
                    <a
                      className={`nav-link${
                        tab === "Outpatient" ? " active show" : ""
                      }`}
                      id={`${tab.toLowerCase()}-tab`}
                      data-bs-toggle="tab"
                      href={`#features-tab-${i + 1}`}
                      role="tab"
                      aria-selected={tab === "Outpatient" ? "true" : "false"}
                      tabIndex={tab === "Outpatient" ? "0" : "-1"}
                    >
                      <h4>{tab}</h4>
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div className="tab-content mt-1 pt-1" id="featuresTabContent">
              {[
                
                 {
                title: "Outpatient (OPD) Managment",
                desc:
                  "Utilise our OPD Management System to effectively oversee outpatient services. It is intended to optimise patient registration, scheduling, and billing for smooth healthcare provision.",
                featuresLeft: [
                  "Patient Registration", "Appointment Scheduling", "Billing and Invoicing", "Queue Management", "EHR (Electronic Health Record)", "Integrated with Lab and Pharmacy",
                ],
                featuresRight: [
                  "Role Based Access Management", "Report and Analytics", "Communication Management", "Multi-Location Management", "Audio Video Consultation", "Mobile App for Patients",
                ],
              },
              {
                title: "Inpatient (IPD) Management",
                desc:
                  "Our IPD Management System, which provides extensive tools for admissions, bed allocation, treatment tracking, and discharge procedures, can improve inpatient care.",
                featuresLeft: [
                  "Inpatient Registration", "Admission", "Ward Management", "Radiology Integration", "Pharmacy Integration", "OT Management",
                ],
                featuresRight: [
                  "Role Based Access Management", "Report and Analytics", "IP Discharge", "IP Billing", "Templates", "Gyneac Care",
                ],
              },
              {
                title: "Appointment Scheduling",
                desc:
                  "Our Appointment Scheduling System streamlines the process of booking, managing, and tracking patient appointments, ensuring efficient use of resources and improved patient satisfaction.",
                featuresLeft: [
                  "OPD Registration", "Provision to set doctor’s available timings.", "Patient can request for online appointment.", "Doctor can manage appointments.", "Doctor Occupancy Management", "Appointment API",
                ],
                featuresRight: [
                  "Role Based Access Management", "Report and Analytics", "Appointments Notification", "Pre-Appointment Checklist", "Predefined Templates", "Queue Management",
                ],
              },
              {
                title: "Billing Management",
                desc:
                  "Our Billing Management System streamlines the process of managing patient billing, ensuring accurate invoicing and improved financial tracking.",
                featuresLeft: [
                  "Add service charges of Hospital.", "Add service charges of Doctor.", "Include the tax master in the billing.", "Define payment terms and conditions.", "Payment API Integration", "Utility for advance collection.",
                ],
                featuresRight: [
                  "Automated billing processes.", "Look up bills using simple search terms", "Discharged billing management", "Credit Management", "Predefined Templates", "360° View on Billing",
                ],
              },
              {
                title: "Pharmacy Management",
                desc:
                  "Our Pharmacy Management System streamlines the process of managing patient prescriptions, ensuring accurate dispensing and improved inventory tracking.",
                featuresLeft: [
                  "Purchase management.", "Inventory management.", "Vendor & Supplier management.", "Cash & Credit management.", "Payment API Integration", "Utility for advance collection.",
                ],
                featuresRight: [
                  "Alerts facility on minimum or zero stock.", "Internal department issuance of drugs", "Result distribution and reporting.", "Quality control and assurance.", "Multi-location inventory management", "360° View on Inventory",
                ],
              },
              {
                title: "Laboratory Management",
                desc:
                  "Our Laboratory Management System streamlines the process of managing lab tests and patient samples, ensuring accurate results and improved workflow.",
                featuresLeft: [
                  "Sample management", "Test management", "Result management", "Inventory management", "Reporting and analytics", "Integration with other systems",
                ],
                featuresRight: [
                  "Specimen tracking", "Test scheduling and management", "Result distribution and reporting", "Quality control and assurance", "Multi-location inventory management", "360° View on Inventory",
                ],
              },
              {
                title: "Operation Theatre Management",
                desc:
                  "Our Operation Theatre Management System streamlines the process of managing surgical procedures and patient care, ensuring efficient workflows and improved outcomes.",
                featuresLeft: [
                  "surgery management with anesthesia tracking", "Patient monitoring and care", "Equipment management", "Inventory management", "Reporting and analytics", "Integration with other systems",
                ],
                featuresRight: [
                  "Patient registration and check-in", "Pre-operative assessments", "Intra-operative monitoring", "Post-operative care and follow-up", "Patient feedback and satisfaction tracking", "360° View of Patient Journey",
                ],
              },
              {
                title: "Nursing",
                desc:
                  "Our Nursing Management System streamlines the process of managing patient care, ensuring efficient workflows and improved outcomes.",
                featuresLeft: [
                  "Nursing Note Management", "Patient monitoring and care", "Medication management", "Care plan management", "Patient education and engagement",
                ],
                featuresRight: [
                  "Collaboration with interdisciplinary teams", "Nursing care plan development", "Intra-operative monitoring", "Patient feedback and satisfaction tracking", "360° View of Patient Journey",
                ],
              },
              {
                title: "Telehealth Management",
                desc:
                  "Our Telehealth Management System streamlines the process of managing patient care, ensuring efficient workflows using telecommunication technologies like video conferencing and remote monitoring.",
                featuresLeft: [
                  "Telehealth Note Management", "Remote patient monitoring", "Virtual consultations", "Telehealth workflow optimization", "Remote patient education and engagement",
                ],
                featuresRight: [
                  "Telehealth care plan development", "Remote patient assessment", "Telehealth technology integration", "Patient feedback and satisfaction tracking", "360° View of Patient Journey",
                ],
              },
              {
                title: "Account Management",
                desc:
                  "Account Management System streamlines the process of managing financial accounts, ensuring accurate tracking and improved financial reporting.",
                featuresLeft: [
                  "Account Creation and Management", "Transaction History Tracking", "Financial Reporting and Analytics", "Budgeting and Forecasting", "Integration with Banking Systems",
                ],
                featuresRight: [
                  "GST Compliance", "Multi-Currency Support", "Multi Location Accounting", "Automated Tax Calculations", "360° View of Financial Health",
                ],
              },
              {
                title: "Ambulance Management",
                desc:
                  "Ambulance Management System streamlines the process of managing ambulance services, ensuring efficient dispatch and improved patient care.",
                featuresLeft: [
                  "Ambulance Dispatch Management", "Patient Tracking and Management", "Emergency Response Coordination", "Vehicle Maintenance Tracking", "Integration with Hospital Systems",
                ],
                featuresRight: [
                  "Ambulance Billing and Invoicing", "Insurance Claim Management", "Payment Processing and Reconciliation", "Ambulance Usage Analytics", "360° View of Ambulance Operations",
                ],
              },
              {
                title: "Blood Bank Management",
                desc:
                  "Blood Bank Management System streamlines the process of managing blood donations, ensuring efficient tracking and improved patient care.",
                featuresLeft: [
                  "Blood Donation Management", "Donor Tracking and Management", "Emergency Blood Request Coordination", "Blood Inventory Tracking", "Integration with Hospital Systems",
                ],
                featuresRight: [
                  "Blood Billing and Invoicing", "Insurance Claim Management", "Payment Processing and Reconciliation", "Blood Usage Analytics", "360° View of Blood Operations",
                ],
              },
              {
                title: "HRMS, Payroll",
                desc:
                  "HRMS and Payroll System streamlines the process of managing employee records, ensuring efficient tracking and improved HR operations.",
                featuresLeft: [
                  "Employee Information Management", "Leave and Attendance Tracking", "Payroll Processing and Management", "Performance Evaluation and Management", "Integration with HR Systems",
                ],
                featuresRight: [
                  "Recruitment Management", "Onboarding and Offboarding Management", "Employee Training and Development", "Employee Self-Service Portal", "360° View of Employee Operations",
                ],
              },
              {
                title: "Inventory Management",
                desc:
                  "The Inventory Management System streamlines the process of managing stock levels, ensuring efficient tracking and improved inventory operations.",
                featuresLeft: [
                  "Stock Level Monitoring", "Order Management", "Supplier Management", "Inventory Valuation", "Integration with Sales Systems",
                ],
                featuresRight: [
                  "Warehouse Management", "Inventory Tracking", "Barcode Scanning", "Real-time Stock Updates", "360° View of Inventory",
                ],
              },
              {
                title: "Health Imaging Management",
                desc:
                  "DICOM and Health Imaging Management System streamlines the process of managing medical images, ensuring efficient tracking and improved patient care.",
                featuresLeft: [
                  "Dicom Management", "Patient Health Imaging Management", "Image Storage and Retrieval", "Integration with PACS", "Advanced Image Analytics",
                ],
                featuresRight: [
                  "Image Compare Tool for Doctors", "Image Annotation and Markup", "Image Quality Assessment", "Image Segmentation", "360° View of Patient Health",
                ],
              },
              {
                title: "Referral Management",
                desc:
                  "Hospital Referral Management System streamlines the process of managing patient referrals, ensuring efficient tracking and improved patient care.",
                featuresLeft: [
                  "Referral Management for Patients", "Referral Tracking and Follow-up", "Integration with EHR", "Patient Communication Tools", "Referral Analytics Dashboard",
                ],
                featuresRight: [
                  "Referral charge management", "Referral Prioritization", "Referral Outcome Tracking", "Referral Documentation Management", "360° View of Patient",
                ],
              },
              {
                title: "Inssurance Management",
                desc:
                  "Insurance Management System streamlines the process of managing insurance policies, ensuring efficient tracking and improved customer service.",
                featuresLeft: [
                  "Insurance Policy Management", "Claims Processing and Tracking", "Integration with EHR", "Patient Communication Tools", "Insurance Analytics Dashboard",
                ],
                featuresRight: [
                  "Settlement Management", "Insurance Prioritization", "Insurance Outcome Tracking", "Insurance Documentation Management", "360° View of Insurance",
                ],
              },
              {
                title: "MIS, Reporting",
                desc:
                  "Management Information System (MIS) provides comprehensive reporting and analytics capabilities, enabling data-driven decision-making.",
                featuresLeft: [
                  "MIS Dashboard", "Custom Reporting", "Data Visualization Tools", "OPD Collection report", "Claims Analysis report",
                ],
                featuresRight: [
                  "MIS Integration", "Stock purchase requisitions", "Hospital revenue service wise report", "Patient demographics report", "360° View of MIS",
                ],
              },
              {
                title: "Hospital Analytics Management",
                desc:
                  "Hospital Analytics Management System provides comprehensive reporting and analytics capabilities, enabling data-driven decision-making.",
                featuresLeft: [
                  "Analytics Dashboard", "Custom Reporting", "Data Visualization Tools", "Predictive Analytics", "Patient Flow Analytics",
                ],
                featuresRight: [
                  "Power BI Integration", "Hospital API Integration", "Data Warehouse Integration", "Custom API Development", "360° View of Analytics",
                ],
              },
              {
                title: "Reception Management",
                desc:
                  "Reception Management System provides comprehensive reporting and analytics capabilities, enabling data-driven decision-making.",
                featuresLeft: [
                  "Patient Registration(IPD & OPD)", "Generate Patient ID Card", "Appointment Scheduling", "Bed Allotment", "Insurance Claims",
                ],
                featuresRight: [
                  "Blood Donor Registration", "Patient Discharge Management", "Consent Forms", "Billing & Payment", "360° View of Desk",
                ],
                }
              ].map(({ title, desc, featuresLeft, featuresRight }, i) => (
                <div
                  className={`tab-pane fade${
                    title === "Outpatient (OPD) Managment" ? " active show" : ""
                  }`}
                  id={`features-tab-${i + 1}`}
                  role="tabpanel"
                  aria-labelledby={`${title
                    .toLowerCase()
                    .replace(/\s/g, "-")}-tab`}
                  key={title}
                >
                  <Row className="align-items-center PY-4">
                    <Col
                      lg={7}
                      className="order-2 order-lg-1 mt-3 mt-lg-0 d-flex flex-column justify-content-center"
                    >
                      <h3
                        style={{
                         
                          fontWeight: 600,
                        }}
                      >
                        {title}
                      </h3>
                      <p className="fst-italic" style={{ color: "#444" }}>
                        {desc}
                      </p>
                      <table>
                        <tbody>
                          <tr>
                            <td style={{ width: "50%", paddingRight: "15px" }}>
                              <ul className="medisevas-feature-list">
                                {featuresLeft.map((feat, idx) => (
                                  <li key={idx}>
                                    <i className="bi bi-check2-all"></i>{" "}
                                    <span>{feat}</span>
                                  </li>
                                ))}
                              </ul>
                            </td>
                            <td style={{ width: "50%", paddingLeft: "15px" }}>
                              <ul className="medisevas-feature-list">
                                {featuresRight.map((feat, idx) => (
                                  <li key={idx}>
                                    <i className="bi bi-check2-all"></i>{" "}
                                    <span>{feat}</span>
                                  </li>
                                ))}
                              </ul>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </Col>
                    <Col
                      lg={5}
                      className="order-1 order-lg-2 text-center mt-4 mt-lg-0 d-flex align-items-center justify-content-center"
                    >
                      <img
                        src={ImgWebp}
                        alt="Features Illustration"
                        className="img-fluid"
                        draggable={false}
                        style={{ height:"450px" }}
                      />
                    </Col>
                  </Row>
                </div>
              ))}
            </div>
          </Container>
        </section>

        {/* 2. Services Section - Alternating Blocks */}
        <section id="services" className="services section light-background">
          <Container>
            <div className="section-title text-center mb-5">
              <h2>Achieve More With Medisevas HealthCare Software</h2>
              <p>
                Designed to operate locally for your convenience.Appreciated
                worldwide across various continents.
              </p>
            </div>

            <Row className="g-5">
              {servicesData.map((service, idx) => (
                <Col key={idx} lg={12}>
                  <div className="service-card">
                    {service.imgFirst && (
                      <div className="service-img-wrapper">
                        <img
                          src={service.imgSrc}
                          alt={service.imgAlt}
                          className="img-fluid"
                          draggable={false}
                        />
                      </div>
                    )}
                    <div className="service-text">
                      <h4>{service.title}</h4>
                      <p>{service.description}</p>
                    </div>
                    {!service.imgFirst && (
                      <div className="service-img-wrapper">
                        <img
                          src={service.imgSrc}
                          alt={service.imgAlt}
                          className="img-fluid"
                          draggable={false}
                        />
                      </div>
                    )}
                  </div>
                </Col>
              ))}
            </Row>
          </Container>
        </section>

        
      </div>
      </div>
      {/* 3. CTA Section - Buttons now use navigateAndScroll */}
        <section className="medisevas-section medisevas-dark-bg py-5">
          <div className="container text-center">
            <h3>
              Assisting You in Expanding Without Boundaries,
              <br />
              Your Development is Our Main Concern
            </h3>
            <p>
              Schedule a demonstration, and our representative will provide you
              with an in-depth overview of our product and address any lingering
              questions.
            </p>
            <div className="hero-buttons mb-3">
              {/* Contact with Us */}
              <a
                className="medisevas-btn medisevas-btn-outline mx-1"
                href="/contact-us"
                onClick={navigateAndScroll("/contact-us")}
              >
                Contact with Us
              </a>

              {/* Book a Demo */}
              <a
                className="medisevas-btn medisevas-btn-success mx-1"
                href="/contact-us"
                onClick={navigateAndScroll("/contact-us")}
              >
                Book a Demo
              </a>

              {/* Partner with Us */}
              <a
                className="medisevas-btn medisevas-btn-outline mx-1"
                href="/partner-with-us"
                onClick={navigateAndScroll("/partner-with-us")}
              >
                Partner with Us
              </a>
            </div>
          </div>
        </section>
    </div>
    </>
  );
};
export default AyurvedicClinicalModule;
